/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { createSelector, createSlice } from '@reduxjs/toolkit';
import { ThunkStatus } from '../../../enums/ThunkStatus';
import { resendInvitation } from './invitation.resend.thunk';

/* Initial state */
const initialState = {
  status: ThunkStatus.IDLE,
  error: undefined,
  invitationId: undefined,
  dialog: { open: false },
};

/* Slice */
export const resendInvitationSlice = createSlice({
  name: 'resendInvitation',
  initialState,
  reducers: {
    updateInvitationId(state, action) {
      state.invitationId = action.payload;
    },
    toggleDialog(state, action) {
      state.dialog.open = action.payload;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(resendInvitation.pending, (state) => {
        state.status = ThunkStatus.LOADING;
      })
      .addCase(resendInvitation.fulfilled, (state) => {
        state.status = ThunkStatus.SUCCEEDED;
      })
      .addCase(resendInvitation.rejected, (state) => {
        state.status = ThunkStatus.FAILED;
      });
  },
});

/* Selectors */
const selectResendInvitation = state => state[resendInvitationSlice.name];
export const selectStatus = createSelector(selectResendInvitation, s => s.status);
export const selectInvitationId = createSelector(selectResendInvitation, s => s.invitationId);
export const selectDialog = createSelector(selectResendInvitation, s => s.dialog);

/* Actions */
export const { updateInvitationId, toggleDialog } = resendInvitationSlice.actions;
